// src/UserFormPage.js

import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Layout,
  Row,
  Col,
  Breadcrumb,
  Card
} from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { ServiceUtils } from "../../../Shared/Utils/ServiceUtils";
import { alertService } from "../../../Shared/Utils/ToasterUtils";
import { useLocation } from 'react-router-dom';
const { Content } = Layout;





const AddEditRole = ({ ...props }) => {
  const location = useLocation();
  const routeUrl = location.pathname.split('/')[2];
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { dept_id } = useParams();
  const [userPermissions, setUserPermissions] = useState([]);
  const [users, setUsers] = useState([]);
  const [loader, setLoader] = useState(true);
  const [departments, setDepartments] = useState([]);


  useEffect(() => {
    if(dept_id) {
      getPermissionsData();
    } else {
      setLoader(false);
    }
    if(routeUrl && routeUrl === 'addSubDepartment') fetchDepartments()
    getUserPermissions();
    getUsers();
  }, []);

  let subDepartmentId = '';
  if(routeUrl === 'addSubDepartment') {
     subDepartmentId = '';
  } else {
    subDepartmentId = JSON.parse(JSON.stringify(localStorage.getItem("subdept_id")));
  }


  // method to fetch defaultData
  const getPermissionsData = () => {
    let payload = {
      dept_id: Number(dept_id),
      subdept_id: Number(JSON.parse(
        JSON.stringify(localStorage.getItem("subdept_id"))
      )),
    };
    ServiceUtils.postRequest("permissionData", payload).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          let permissionData = JSON.parse(JSON.stringify(response?.data?.data));
          form.setFieldsValue({
            users: permissionData?.users.map(Number),
            permissions: permissionData?.permissions.map(Number),
            department: permissionData?.deptName,
            subDepartment: permissionData?.subdeptName,
          });
          setLoader(false);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      }
    );
  };

  const fetchDepartments = () => {
    ServiceUtils.getRequest("listDepartments").then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          let departmentIds = JSON.parse(JSON.stringify(response?.data?.data));
          setDepartments(departmentIds);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      }
    );
  };

// method to fetch permissions list
  const getUserPermissions = () => {
      let payload={
        type : "permissions"
      }
      ServiceUtils.postRequest('lookup', payload).then(
        (response) => {
          if (response.status === 200 && response?.data.status) {
            const permissionList = response?.data?.data;
            setUserPermissions(permissionList);
          } 
          else if(response.status === 401 ){
            navigate('/logout');
          }
          else {
            alertService.error(response.data.message)
          }
        },
        (error) => {
          alertService.error('Error while fetching data')
          console.log(error)
        }
      );
    }
// method to fetch users list
    const getUsers = () => {
        let payload={};
        ServiceUtils.postRequest('surveyArcAttendees', payload).then(
          (response) => {
            if (response.status === 200 && response?.data.status) {
              const users = response?.data?.data;
              setUsers(users);
            } 
            else if(response.status === 401 ){
              navigate('/logout');
            }
            else {
              alertService.error(response.data.message)
            }
          },
          (error) => {
            alertService.error('Error while fetching data')
            console.log(error)
          }
        );
      }

  // method triggered on change of field values
  const handleInputChange = (key, value, action) => {
    // if (action === "onchange") {
    //   setUserData({
    //     ...userData,
    //     [key]: value,
    //   });
    // }
  };

  const SubmitButton = ({ form, children }) => {
    const [submittable, setSubmittable] = useState(false);

    const values = Form.useWatch([], form);
    useEffect(() => {
      form
        .validateFields({
          validateOnly: true,
        })
        .then(() => setSubmittable(true))
        .catch(() => setSubmittable(false));
    }, [form, values]);
    return (
      <Button type="primary" htmlType="submit" disabled={!submittable} onClick={handleSave}>
        {children}
      </Button>
    );
  };

  const handleSave = (values) => {
    addEditDeptAndSubDept();
  };


  const addEditDeptAndSubDept = () => {
    const formValues = form.getFieldsValue(true); 
    let payload = {
        "type": dept_id  ? 'edit' : 'add',
        "permissionsData": formValues
    }
    const subdept_id = JSON.parse(JSON.stringify(localStorage.getItem('subdept_id')));
    if (routeUrl === 'addDepartment' ) payload['permissionsData']['type'] = 'department';
    else if (routeUrl === 'addSubDepartment') payload['permissionsData']['type'] = 'subdepartment';
    if(dept_id) {
      payload['permissionsData']['departmentId'] = dept_id;
      payload['permissionsData']['subDepartmentId'] = subdept_id;
    }
    ServiceUtils.postRequest('permissionOps', payload).then(
        (response) => {
          if (response.status === 200 && response?.data.status) {
              navigate("/admin/settings");
          } 
          else if(response.status === 401 ){
            navigate('/logout');
          }
          else {
            alertService.error(response.data.message)
          }
        },
        (error) => {
          alertService.error('Error while fetching data')
          console.log(error)
        }
      );
  }

  return (
    <div>
      {!loader && (
        <div>
          <Card
            style={{ width: "100%", height: "fit-content" }}
            bodyStyle={{ padding: "10px" }}
          >
            {dept_id ? (
              <Breadcrumb
                separator=""
                items={[
                  {
                    title: (
                      <>
                        <div
                          className="settings-breadcrumb"
                          onClick={() => navigate("/admin/settings")}
                        >
                          <div>
                            <ArrowLeftOutlined className="arrow-display" />
                            <span style={{ marginLeft: "2px" }}>Settings</span>
                          </div>
                        </div>
                      </>
                    ),
                  },
                  {
                    type: "separator",
                  },
                  {
                    title: (
                      <div style={{ display: "flex" }}>
                        <div style={{ margin: "0px 2px" }}>Edit</div>
                      </div>
                    ),
                  },
                ]}
              />
            ) : (
              <Breadcrumb
                separator=""
                items={[
                  {
                    title: (
                      <>
                        <div
                          className="settings-breadcrumb"
                          onClick={() => navigate("/admin/settings")}
                        >
                          <div>
                            <ArrowLeftOutlined className="arrow-display" />
                            <span style={{ marginLeft: "2px" }}>Settings</span>
                          </div>
                        </div>
                      </>
                    ),
                  },
                  {
                    type: "separator",
                  },
                  {
                    title: (
                      <div style={{ display: "flex" }}>
                        {routeUrl === "addDepartment" ? (
                          <div style={{ margin: "0px 2px" }}>Add Department</div>
                        ) : (
                          <div style={{ margin: "0px 2px" }}>
                            Add SubDepartent
                          </div>
                        )}
                      </div>
                    ),
                  },
                ]}
              />
            )}
          </Card>
          <Content
            style={{
              padding: "24px",
              background: "#fff",
              height: "calc(100vh - 90px)",
            }}
          >
            <Form
              form={form}
              // initialValues={userData && userData}
              name="validateOnly"
              layout="vertical"
              autoComplete="off"
            >
              <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                {(dept_id || routeUrl === "addDepartment") && (
                  <Col
                    className="gutter-row"
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "50%" }}
                    lg={{ flex: "25%" }}
                    xl={{ flex: "25%" }}
                  >
                    <label
                      class="form-label text-ellipsis-one-line"
                      style={{ marginBottom: "5px" }}
                    >
                      Department
                    </label>
                    <Form.Item
                      name="department"
                      rules={[
                        {
                          required: true,
                          message: "Department is required.",
                        },
                      ]}
                    >
                      <Input
                        onChange={(e) =>
                          handleInputChange(
                            "department",
                            e.target.value,
                            "onchange"
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                )}
                { routeUrl === "addSubDepartment" &&
                  <Col
                  className="gutter-row"
                  xs={{ flex: "100%" }}
                  sm={{ flex: "100%" }}
                  md={{ flex: "50%" }}
                  lg={{ flex: "25%" }}
                  xl={{ flex: "25%" }}
                >
                  <label
                    class="form-label text-ellipsis-one-line"
                    style={{ marginBottom: "5px" }}
                  >
                    Department
                  </label>
                  <Form.Item
                    name="departmentId"
                    rules={[
                      {
                        required: true,
                        message: "Department Id is required.",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      onChange={(e) => {
                        handleInputChange("departmentId", e, "onchange");
                      }}
                      options={departments}
                      allowClear
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>}
                {(dept_id || routeUrl === "addSubDepartment") && (
                  <Col
                    className="gutter-row"
                    xs={{ flex: "100%" }}
                    sm={{ flex: "100%" }}
                    md={{ flex: "50%" }}
                    lg={{ flex: "25%" }}
                    xl={{ flex: "25%" }}
                  >
                    <label
                      class="form-label text-ellipsis-one-line"
                      style={{ marginBottom: "5px" }}
                    >
                      Sub Department
                    </label>
                    <Form.Item
                      name="subDepartment"
                      rules={
                        subDepartmentId !== "null" ?
                        [
                        {
                          required: true,
                          message: "Sub Department is required.",
                        },
                      ] : []
                    }
                    >
                      <Input
                        disabled={subDepartmentId === "null"}
                        onChange={(e) =>
                          handleInputChange(
                            "subDepartment",
                            e.target.value,
                            "onchange"
                          )
                        }
                      />
                    </Form.Item>
                  </Col>
                )}
                <Col
                  className="gutter-row"
                  xs={{ flex: "100%" }}
                  sm={{ flex: "100%" }}
                  md={{ flex: "50%" }}
                  lg={{ flex: "25%" }}
                  xl={{ flex: "25%" }}
                >
                  <label
                    class="form-label text-ellipsis-one-line"
                    style={{ marginBottom: "5px" }}
                  >
                    Permissions
                  </label>
                  <Form.Item
                    name="permissions"
                    rules={[
                      {
                        required: true,
                        message: "Permissions is required.",
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      showSearch
                      onChange={(e) => {
                        handleInputChange("permissions", e, "onchange");
                      }}
                      options={userPermissions}
                      allowClear
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>
                <Col
                  className="gutter-row"
                  xs={{ flex: "100%" }}
                  sm={{ flex: "100%" }}
                  md={{ flex: "50%" }}
                  lg={{ flex: "25%" }}
                  xl={{ flex: "25%" }}
                >
                  <label
                    class="form-label text-ellipsis-one-line"
                    style={{ marginBottom: "5px" }}
                  >
                    Users
                  </label>
                  <Form.Item
                    name="users"
                    rules={[
                      {
                        required: true,
                        message: "Users is required.",
                      },
                    ]}
                  >
                    <Select
                      mode="multiple"
                      showSearch
                      onChange={(e) => {
                        handleInputChange("users", e, "onchange");
                      }}
                      options={users}
                      allowClear
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
            <div
              className="submit-block"
              style={{ position: "absolute", bottom: "5px", right: "5px" }}
            >
              <div style={{ paddingRight: "10px" }}>
                <SubmitButton form={form}>
                  {dept_id ? "Update" : "Save"}
                </SubmitButton>
              </div>
              <Button onClick={() => navigate("/admin/settings")}>
                Cancel
              </Button>
            </div>
          </Content>
        </div>
      )}
    </div>
  );
};

export default AddEditRole;
